import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

interface Props {
  destino: string;
  /** Veio do menu Teleportar (não do portal no chão): o texto fala em teleportar. */
  teleporte?: boolean;
  onAccept(): void;
  onRefuse(): void;
}

export function PortalGump({ destino, teleporte = false, onAccept, onRefuse }: Props) {
  const k = teleporte ? 'teleporte' : 'portal';
  useFechar(onRefuse, { modal: true });

  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" aria-labelledby="portal-title" onClick={e => e.stopPropagation()}>
        <Gump
          title={t(`${k}.titulo`)}
          action={
            <button type="button" className="btn btn--tiny btn--ghost" onClick={onRefuse} aria-label={t('comum.fechar')}>
              ×
            </button>
          }
        >
          <div className="stack">
            <p id="portal-title">{t(`${k}.pergunta`, { destino })}</p>
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{t('portal.ficar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{t(`${k}.ir`)}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}
